import { copy } from "shared/assets";
import { IFieldType, IFormFields, IImageTypes } from "shared/types";

const { imageProperties, imageForm, errors } = copy;

export const fields: IFormFields = [
  {
    name: "image",
    label: imageProperties.image.title,
    type: IFieldType.image,
    validation: {
      required: errors.required,
      type: {
        types: [...Object.values(IImageTypes)],
        message: imageForm.validation.type,
      },
      fileSize: {
        maxSize: 31457280, // 30 MB
        message: imageForm.validation.fileSize,
      },
    },
  },
  {
    name: "description",
    label: imageProperties.description.title,
    type: IFieldType.textarea,
  },
];
